import { FlagGetter } from "@/FeatureFlag";
import { userIsFPEmployee } from "@/util";

/** WTM 2.0 is flag-gated and FP-employee-only while we dogfood via masquerade. */
export function isWtm2Enabled(flag: FlagGetter): boolean {
  return flag("webTrackerMonitoringWtm2") && userIsFPEmployee();
}
